import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ServicoTenant {
  get hostAtual() {
    return window.location.hostname.toLowerCase();
  }

  get slugTenantAtual() {
    if (this.ehHostAdministrativoGlobal()) {
      return '';
    }

    const slug = this.hostAtual.split('.')[0] || '';
    return slug === 'www' ? '' : slug;
  }

  get chaveTokenTerminal() {
    return `pontojwm_terminal_token_${this.slugTenantAtual || 'local'}`;
  }

  ehApiLocal() {
    const host = this.hostAtual;
    return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost');
  }

  ehHostAdministrativoGlobal() {
    return ['localhost', '127.0.0.1', 'admin.jwmtecnologia.com.br'].includes(this.hostAtual);
  }

  ehRotaTerminalPublico() {
    const rotaRegistroPublico = window.location.pathname.toLowerCase().startsWith('/registrar');
    return rotaRegistroPublico && !this.ehHostAdministrativoGlobal();
  }

  ehRotaPortalServidor() {
    return window.location.pathname.toLowerCase().startsWith('/servidor');
  }
}
